var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
let className = "icon";
const packs = [];
const iconSpanStyle = {
    display: "inline-block",
    color: "inherit",
    fontStyle: "normal",
    lineHeight: "0",
    textAlign: "center",
    textTransform: "none",
    verticalAlign: "-.125em",
    textRendering: "optimizeLegibility",
};
export function registerIconPack(pack) {
    if ("default" in pack && "__esModule" in pack && pack.__esModule === true) {
        packs.push(pack.default);
    }
    else {
        packs.push(pack);
    }
}
export function getIconPacks() {
    return packs;
}
export function setIconClassName(name) {
    className = name;
}
function treeToElement(tree) {
    return (tree &&
        tree.map((node, i) => React.createElement(node.tag, Object.assign({ key: i }, node.attr), treeToElement(node.child))));
}
export const Icon = React.memo(function Icon(_a) {
    var { icon, size = "1em", title, color, style = {}, children } = _a, svgProps = __rest(_a, ["icon", "size", "title", "color", "style", "children"]);
    if (!icon) {
        console.error(new Error("Icon is missing icon definition"));
    }
    const [pack, iconKey] = React.useMemo(() => {
        if (!icon) {
            return [null, null];
        }
        const split = icon.split(":");
        if (split.length === 3) {
            const [set, theme, iconKey] = split;
            const pack = packs.find((pack) => pack.set === set && pack.theme === theme);
            return [pack, iconKey];
        }
        else if (split.length === 2) {
            const [set, iconKey] = split;
            const pack = packs.find((pack) => pack.set === set && pack.defaultTheme === true) ||
                packs.find((pack) => pack.set === set);
            return [pack, iconKey];
        }
        else {
            return [null, null];
        }
    }, [icon, packs.length]);
    if (!pack) {
        console.warn(`IconPack for icon='${icon}' not found.`);
        return null;
    }
    const iconTree = pack.icons[iconKey];
    if (!iconTree) {
        console.warn(`Icon for icon='${icon}' not found.`);
        return null;
    }
    return (React.createElement("span", { role: "img", "aria-label": iconKey, style: iconSpanStyle, className: className },
        React.createElement("svg", Object.assign({ stroke: "currentColor", fill: "currentColor", strokeWidth: "0" }, svgProps, iconTree.attr, { style: Object.assign({ color }, style), height: size, width: size, xmlns: "http://www.w3.org/2000/svg" }),
            title && React.createElement("title", null, title),
            children,
            treeToElement(iconTree.child))));
});
//# sourceMappingURL=index.js.map